import { useState } from 'react';

import { supabase } from './supabase';

const useFileUploader = (bucket: 'images' | 'invoices', _fileUrl?: string) => {
  const [fileUrl, setFileUrl] = useState(_fileUrl);

  const handleUpload = async (file: File | null) => {
    if (!file) return;

    const fileExt = (file as any).name.split('.').pop();
    const fileName = `${Date.now()}.${fileExt}`;
    const filePath = `${bucket}/${fileName}`;

    const { error } = await supabase.storage.from(bucket).upload(filePath, file);

    if (error) {
      console.error('Upload error:', error.message);
      return;
    }

    const { data } = supabase.storage.from(bucket).getPublicUrl(filePath);

    setFileUrl(data.publicUrl);
  };

  return {
    handleUpload,
    fileUrl,
    setFileUrl,
  };
};

export default useFileUploader;
